import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { codTabBarContainerSx, codTabBarSx } from "./codStyles";
import { NJIM } from "../../../theme/njimTheme";

export interface CodTabItem<T extends string = string> {
  value: T;
  label: string;
  count?: number;
  icon?: React.ReactNode;
}

interface CodTabBarProps<T extends string> {
  value: T;
  tabs: CodTabItem<T>[];
  onChange: (value: T) => void;
}

const TabCountBadge: React.FC<{ count: number; active: boolean }> = ({
  count,
  active,
}) => (
  <Box
    component="span"
    sx={{
      minWidth: 20,
      height: 20,
      px: 0.75,
      borderRadius: "999px",
      backgroundColor: active ? NJIM.white : NJIM.warning,
      color: active ? NJIM.ink : NJIM.white,
      fontSize: 11,
      fontWeight: 700,
      lineHeight: "20px",
      textAlign: "center",
      fontVariantNumeric: "tabular-nums",
    }}
  >
    {count}
  </Box>
);

const CodTabBar = <T extends string>({
  value,
  tabs,
  onChange,
}: CodTabBarProps<T>) => (
  <Box sx={{ ...codTabBarContainerSx, mb: 2 }}>
    <Tabs
      value={value}
      onChange={(_, next) => onChange(next as T)}
      variant="scrollable"
      scrollButtons={false}
      allowScrollButtonsMobile
      sx={codTabBarSx}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          disableRipple
          label={
            <Box
              component="span"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 0.75,
              }}
            >
              {tab.icon}
              {tab.label}
              {tab.count != null && tab.count > 0 && (
                <TabCountBadge count={tab.count} active={value === tab.value} />
              )}
            </Box>
          }
        />
      ))}
    </Tabs>
  </Box>
);

export default CodTabBar;
